var Handlebars = require("../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    return "##### :hatching_chick: Initial release\n";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"each").call(alias1,(depth0 != null ? lookupProperty(depth0,"commitCategories") : depth0),{"name":"each","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":4,"column":0},"end":{"line":9,"column":9}}})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"hasDependencyChanges") : depth0),{"name":"if","hash":{},"fn":container.program(7, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":11,"column":0},"end":{"line":40,"column":7}}})) != null ? stack1 : "");
},"4":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "### :"
    + ((stack1 = alias1((depth0 != null ? lookupProperty(depth0,"emoji") : depth0), depth0)) != null ? stack1 : "")
    + ": "
    + ((stack1 = alias1((depth0 != null ? lookupProperty(depth0,"title") : depth0), depth0)) != null ? stack1 : "")
    + "\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"commits") : depth0),{"name":"each","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":6,"column":0},"end":{"line":8,"column":9}}})) != null ? stack1 : "");
},"5":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "> [`"
    + ((stack1 = alias1((depth0 != null ? lookupProperty(depth0,"shortSha") : depth0), depth0)) != null ? stack1 : "")
    + "`](https://github.com/"
    + ((stack1 = alias1(((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"ownerName")), depth0)) != null ? stack1 : "")
    + "/"
    + ((stack1 = alias1(((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"repoName")), depth0)) != null ? stack1 : "")
    + "/commit/"
    + ((stack1 = alias1((depth0 != null ? lookupProperty(depth0,"sha") : depth0), depth0)) != null ? stack1 : "")
    + ") "
    + ((stack1 = alias1((depth0 != null ? lookupProperty(depth0,"message") : depth0), depth0)) != null ? stack1 : "")
    + "\n";
},"7":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "\n---\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"dependencies") : depth0),{"name":"each","hash":{},"fn":container.program(8, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":14,"column":0},"end":{"line":39,"column":9}}})) != null ? stack1 : "");
},"8":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "### "
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"title") : depth0), depth0)) != null ? stack1 : "")
    + "\nEvent|Package|Before|After\n---|---|---|---\n"
    + ((stack1 = lookupProperty(helpers,"each").call(alias1,(depth0 != null ? lookupProperty(depth0,"added") : depth0),{"name":"each","hash":{},"fn":container.program(9, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":18,"column":0},"end":{"line":20,"column":9}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"each").call(alias1,(depth0 != null ? lookupProperty(depth0,"removed") : depth0),{"name":"each","hash":{},"fn":container.program(11, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":21,"column":0},"end":{"line":23,"column":9}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"each").call(alias1,(depth0 != null ? lookupProperty(depth0,"moved") : depth0),{"name":"each","hash":{},"fn":container.program(13, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":24,"column":0},"end":{"line":26,"column":9}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"each").call(alias1,(depth0 != null ? lookupProperty(depth0,"locked") : depth0),{"name":"each","hash":{},"fn":container.program(15, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":27,"column":0},"end":{"line":29,"column":9}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"each").call(alias1,(depth0 != null ? lookupProperty(depth0,"unlocked") : depth0),{"name":"each","hash":{},"fn":container.program(17, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":30,"column":0},"end":{"line":32,"column":9}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"each").call(alias1,(depth0 != null ? lookupProperty(depth0,"downgraded") : depth0),{"name":"each","hash":{},"fn":container.program(19, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":33,"column":0},"end":{"line":35,"column":9}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"each").call(alias1,(depth0 != null ? lookupProperty(depth0,"upgraded") : depth0),{"name":"each","hash":{},"fn":container.program(21, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":36,"column":0},"end":{"line":38,"column":9}}})) != null ? stack1 : "");
},"9":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ":floppy_disk: Added|[`"
    + ((stack1 = alias1((depth0 != null ? lookupProperty(depth0,"name") : depth0), depth0)) != null ? stack1 : "")
    + "`](https://yarnpkg.com/package/"
    + ((stack1 = alias1((depth0 != null ? lookupProperty(depth0,"name") : depth0), depth0)) != null ? stack1 : "")
    + ")||`"
    + ((stack1 = alias1((depth0 != null ? lookupProperty(depth0,"range") : depth0), depth0)) != null ? stack1 : "")
    + "`\n";
},"11":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ":toilet: Removed|[`"
    + ((stack1 = alias1((depth0 != null ? lookupProperty(depth0,"name") : depth0), depth0)) != null ? stack1 : "")
    + "`](https://yarnpkg.com/package/"
    + ((stack1 = alias1((depth0 != null ? lookupProperty(depth0,"name") : depth0), depth0)) != null ? stack1 : "")
    + ")|`"
    + ((stack1 = alias1((depth0 != null ? lookupProperty(depth0,"range") : depth0), depth0)) != null ? stack1 : "")
    + "`\n";
},"13":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ":school_satchel: Moved|[`"
    + ((stack1 = alias1((depth0 != null ? lookupProperty(depth0,"name") : depth0), depth0)) != null ? stack1 : "")
    + "`](https://yarnpkg.com/package/"
    + ((stack1 = alias1((depth0 != null ? lookupProperty(depth0,"name") : depth0), depth0)) != null ? stack1 : "")
    + ")|"
    + ((stack1 = alias1((depth0 != null ? lookupProperty(depth0,"oldTypesString") : depth0), depth0)) != null ? stack1 : "")
    + "|"
    + ((stack1 = alias1((depth0 != null ? lookupProperty(depth0,"newType") : depth0), depth0)) != null ? stack1 : "")
    + "\n";
},"15":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ":lock: Locked|[`"
    + ((stack1 = alias1((depth0 != null ? lookupProperty(depth0,"name") : depth0), depth0)) != null ? stack1 : "")
    + "`](https://yarnpkg.com/package/"
    + ((stack1 = alias1((depth0 != null ? lookupProperty(depth0,"name") : depth0), depth0)) != null ? stack1 : "")
    + ")|`"
    + ((stack1 = alias1((depth0 != null ? lookupProperty(depth0,"oldRange") : depth0), depth0)) != null ? stack1 : "")
    + "`|`"
    + ((stack1 = alias1((depth0 != null ? lookupProperty(depth0,"newRange") : depth0), depth0)) != null ? stack1 : "")
    + "`\n";
},"17":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ":unlock: Unlocked|[`"
    + ((stack1 = alias1((depth0 != null ? lookupProperty(depth0,"name") : depth0), depth0)) != null ? stack1 : "")
    + "`](https://yarnpkg.com/package/"
    + ((stack1 = alias1((depth0 != null ? lookupProperty(depth0,"name") : depth0), depth0)) != null ? stack1 : "")
    + ")|`"
    + ((stack1 = alias1((depth0 != null ? lookupProperty(depth0,"oldRange") : depth0), depth0)) != null ? stack1 : "")
    + "`|`"
    + ((stack1 = alias1((depth0 != null ? lookupProperty(depth0,"newRange") : depth0), depth0)) != null ? stack1 : "")
    + "`\n";
},"19":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ":fallen_leaf: Downgraded|[`"
    + ((stack1 = alias1((depth0 != null ? lookupProperty(depth0,"name") : depth0), depth0)) != null ? stack1 : "")
    + "`](https://yarnpkg.com/package/"
    + ((stack1 = alias1((depth0 != null ? lookupProperty(depth0,"name") : depth0), depth0)) != null ? stack1 : "")
    + ")|`"
    + ((stack1 = alias1((depth0 != null ? lookupProperty(depth0,"oldRange") : depth0), depth0)) != null ? stack1 : "")
    + "`|`"
    + ((stack1 = alias1((depth0 != null ? lookupProperty(depth0,"newRange") : depth0), depth0)) != null ? stack1 : "")
    + "`\n";
},"21":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ":sunflower: Upgraded|[`"
    + ((stack1 = alias1((depth0 != null ? lookupProperty(depth0,"name") : depth0), depth0)) != null ? stack1 : "")
    + "`](https://yarnpkg.com/package/"
    + ((stack1 = alias1((depth0 != null ? lookupProperty(depth0,"name") : depth0), depth0)) != null ? stack1 : "")
    + ")|`"
    + ((stack1 = alias1((depth0 != null ? lookupProperty(depth0,"oldRange") : depth0), depth0)) != null ? stack1 : "")
    + "`|`"
    + ((stack1 = alias1((depth0 != null ? lookupProperty(depth0,"newRange") : depth0), depth0)) != null ? stack1 : "")
    + "`\n";
},"23":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "- Code changes: ["
    + ((stack1 = alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"beforeTag") : depth0)) != null ? lookupProperty(stack1,"name") : stack1), depth0)) != null ? stack1 : "")
    + " …\n"
    + ((stack1 = alias1((depth0 != null ? lookupProperty(depth0,"afterTagName") : depth0), depth0)) != null ? stack1 : "")
    + "](https://github.com/"
    + ((stack1 = alias1((depth0 != null ? lookupProperty(depth0,"ownerName") : depth0), depth0)) != null ? stack1 : "")
    + "/"
    + ((stack1 = alias1((depth0 != null ? lookupProperty(depth0,"repoName") : depth0), depth0)) != null ? stack1 : "")
    + "/compare/"
    + ((stack1 = alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"beforeTag") : depth0)) != null ? lookupProperty(stack1,"name") : stack1), depth0)) != null ? stack1 : "")
    + "..."
    + ((stack1 = alias1((depth0 != null ? lookupProperty(depth0,"afterTagName") : depth0), depth0)) != null ? stack1 : "")
    + "?diff=unified&w=1)\n("
    + ((stack1 = __default(require("../../../node_modules/handlebars-helper-plural/index.js")).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"comparison") : depth0)) != null ? lookupProperty(stack1,"total_commits") : stack1),"commit",{"name":"$handlebars-helper-plural","hash":{},"data":data,"loc":{"start":{"line":47,"column":1},"end":{"line":47,"column":64}}})) != null ? stack1 : "")
    + ")\n";
},"25":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "- jsDelivr:\n[cdn.jsdelivr.net/npm/"
    + ((stack1 = alias1((depth0 != null ? lookupProperty(depth0,"packageName") : depth0), depth0)) != null ? stack1 : "")
    + "@"
    + ((stack1 = alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"pkg") : depth0)) != null ? lookupProperty(stack1,"version") : stack1), depth0)) != null ? stack1 : "")
    + "](https://cdn.jsdelivr.net/npm/"
    + ((stack1 = alias1((depth0 != null ? lookupProperty(depth0,"packageName") : depth0), depth0)) != null ? stack1 : "")
    + "@"
    + ((stack1 = alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"pkg") : depth0)) != null ? lookupProperty(stack1,"version") : stack1), depth0)) != null ? stack1 : "")
    + "/)\n- UNPKG: [unpkg.com/browse/"
    + ((stack1 = alias1((depth0 != null ? lookupProperty(depth0,"packageName") : depth0), depth0)) != null ? stack1 : "")
    + "@"
    + ((stack1 = alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"pkg") : depth0)) != null ? lookupProperty(stack1,"version") : stack1), depth0)) != null ? stack1 : "")
    + "](https://unpkg.com/browse/"
    + ((stack1 = alias1((depth0 != null ? lookupProperty(depth0,"packageName") : depth0), depth0)) != null ? stack1 : "")
    + "@"
    + ((stack1 = alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"pkg") : depth0)) != null ? lookupProperty(stack1,"version") : stack1), depth0)) != null ? stack1 : "")
    + "/)\n";
},"27":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "#### "
    + ((stack1 = __default(require("../../../node_modules/handlebars-helper-plural/index.js")).call(alias1,(depth0 != null ? lookupProperty(depth0,"authorsCount") : depth0),"author",{"name":"$handlebars-helper-plural","hash":{},"data":data,"loc":{"start":{"line":56,"column":5},"end":{"line":56,"column":56}}})) != null ? stack1 : "")
    + "\n\n"
    + ((stack1 = lookupProperty(helpers,"each").call(alias1,(depth0 != null ? lookupProperty(depth0,"authors") : depth0),{"name":"each","hash":{},"fn":container.program(28, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":58,"column":0},"end":{"line":59,"column":104}}})) != null ? stack1 : "")
    + "\n";
},"28":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<a href=\""
    + ((stack1 = alias1((depth0 != null ? lookupProperty(depth0,"url") : depth0), depth0)) != null ? stack1 : "")
    + "\" target=_blank><img height=32 width=32\n    alt=\""
    + ((stack1 = __default(require("../../../node_modules/handlebars-helper-plural/index.js")).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"commits") : depth0),"commit",{"name":"$handlebars-helper-plural","hash":{},"data":data,"loc":{"start":{"line":59,"column":9},"end":{"line":59,"column":55}}})) != null ? stack1 : "")
    + " from "
    + ((stack1 = alias1((depth0 != null ? lookupProperty(depth0,"name") : depth0), depth0)) != null ? stack1 : "")
    + "\" src=\""
    + ((stack1 = alias1((depth0 != null ? lookupProperty(depth0,"avatar") : depth0), depth0)) != null ? stack1 : "")
    + "\" /></a> ";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"isInitialRelease") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":41,"column":7}}})) != null ? stack1 : "")
    + "\n---\n"
    + ((stack1 = lookupProperty(helpers,"unless").call(alias1,(depth0 != null ? lookupProperty(depth0,"isInitialRelease") : depth0),{"name":"unless","hash":{},"fn":container.program(23, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":44,"column":0},"end":{"line":48,"column":11}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"isOnNpm") : depth0),{"name":"if","hash":{},"fn":container.program(25, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":49,"column":0},"end":{"line":53,"column":7}}})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = lookupProperty(helpers,"unless").call(alias1,(depth0 != null ? lookupProperty(depth0,"isInitialRelease") : depth0),{"name":"unless","hash":{},"fn":container.program(27, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":55,"column":0},"end":{"line":60,"column":11}}})) != null ? stack1 : "");
},"useData":true});